// Utility service registry — colors follow AU/industry conventions
// Icons use Lucide names (not JSX here, just identifiers)
export const UTILITIES = [
  { key: "water",       label: "Water",           color: "#2563EB", icon: "Droplets" },
  { key: "harvested",   label: "Harvested Water", color: "#C8A2C8", icon: "Droplet" },
  { key: "pumpline",    label: "Pump Line",       color: "#000000", icon: "ArrowRightLeft" },
  { key: "fire",        label: "Fire",            color: "#DC2626", icon: "Flame" },
  { key: "electrical",  label: "Electrical",      color: "#F59E0B", icon: "Zap" },
  { key: "nbn",         label: "NBN",             color: "#9333EA", icon: "Wifi" },
  { key: "telstra",     label: "Telstra",         color: "#F97316", icon: "Phone" },
  { key: "irrigation",  label: "Irrigation",      color: "#14B8A6", icon: "Sprout" },
  { key: "drainage",    label: "Drainage",        color: "#64748B", icon: "CloudDrizzle" },
  { key: "sewer",       label: "Sewer",           color: "#22C55E", icon: "Waves" },
  { key: "gas",         label: "Gas",             color: "#EAB308", icon: "FlaskConical" },
  { key: "stormwater",  label: "Stormwater",      color: "#0284C7", icon: "CloudRain" },
  { key: "recycled",    label: "Recycled Water",  color: "#7C3AED", icon: "Recycle" },
  { key: "unidentified",label: "Unidentified",    color: "#6B7280", icon: "HelpCircle", dash: "8 6" },
  { key: "redundant",   label: "Redundant",       color: "#3F3F46", icon: "Ban",        dash: "2 5" },
  { key: "offset",      label: "Offset",          color: "#111827", icon: "Ruler",      dash: "4 4", measure: true },
];

export const UTIL_BY_KEY = Object.fromEntries(UTILITIES.map(u => [u.key, u]));

export const getUtil = (k) => UTIL_BY_KEY[k] || { key: k, label: k, color: "#000", icon: "Circle" };
